import axios from "axios";
// import router from "@/router";
// import store from "@/store";

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_BASEURL,
});

// Request interceptor for API calls
axiosInstance.interceptors.request.use(
  async (config) => {
    //const _token = localStorage.getItem("vuex.state.auth.token");
    config.headers.Accept = "application/json";
    config.headers["Content-Type"] = "application/json";
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

// // Response interceptor for API calls
// axiosInstance.interceptors.response.use(
//   // response
//   (response) => {
//     //store.dispatch("refreshMintoxAuthToken");
//     return response;
//   },
//   // error
//   (error) => {
//     if (error.response.status === 403) {
//       router.push({ path: "home" });
//     } else {
//       throw error;
//     }
//   }
// );

export default axiosInstance;
